import { useState, useEffect } from 'react';

export default function useLanguageDetection() {
  const [language, setLanguage] = useState(null);

  useEffect(() => {
    if (!language) {
      let lang = navigator.language.slice(0, 2);
      setLanguage(lang);
    }
  }, [language]);

  return language;
}
